module.exports = __webpack_public_path__ + "static/media/xepelin-blanco.2ce1b899.svg";